module.exports = __webpack_public_path__ + "static/img/tips.0f385d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/light/tips.png
// module id = 7kjC
// module chunks = 1